import React from "react";
import { Currency } from "@vwpfs/mary-air-lib/components/air/05-atoms/CurrencyDisplay";
import { Navbar } from "@vwpfs/mary-air-lib/components/air/07-organisms";
import { PageTabs } from "../../../store/AppDisplays";
import { ThemePalette, ThemeShadowSizes } from "@vwpfs/mary-air-lib/theme/_Types";
import { navbarTheme } from "../09-views/00-blocks/ManualBookings/Create/ManualBookBar";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { NavbarStack,
    NavbarStackContent, NavbarStackRight } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Stack";
import { NavbarTitle } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Title";
export enum FormBarSize {
    FULL_WIDTH = "FULL_WIDTH",
    WITH_SIDEBAR = "WITH_SIDEBAR",
    WITH_COLLAPSED_SIDEBAR ="WITH_COLLAPSED_SIDEBAR"
}

interface OwnProps {
    onClick: () =>  void;
    selectedBalance: number;
    isValid?: boolean;
    title: string;
    currentTab?: PageTabs;
    debit?: boolean;
    size?: FormBarSize;
}

/**
 *
 */
type Props = OwnProps;

export const GenerateBar: React.FunctionComponent<Props> = props => (
    <Div
        className={
            `scl-o-formbar ${props.size === FormBarSize.WITH_COLLAPSED_SIDEBAR
                ? "scl-o-formbar--collapsed-sidebar" : ""}`}
        theme={{
            shadow: ThemeShadowSizes.HUGE,
        }}
    >
        <Navbar theme={navbarTheme(props.isValid)} className="scl-h-text-align--left">
            <NavbarStack>
                <NavbarStackContent>
                    <NavbarTitle>
                        {props.title}
                    </NavbarTitle>
                </NavbarStackContent>
                <NavbarStackRight>
                    <Div theme={{ padding: { "": { x: 2 }, "sm": { x: 3 } } }}>
                        <Div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                        >
                            <Div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "stretch",
                                }}
                            >
                                <span
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <span
                                        style={{
                                            paddingLeft: "5px",
                                            textAlign: "right",
                                        }}
                                    >
                                        <span
                                            className="scl-a-label__field scl-a-label__field--as-summary"
                                            style={{
                                                color: "#fff",
                                            }}
                                        >
                                            Selected balance
                                        </span>
                                        <span
                                            className="scl-b-h scl-b-h3 "
                                            style={{
                                                color: "#fff",
                                            }}
                                        >
                                            {
                                                <Currency value={props.selectedBalance} />
                                            }
                                        </span>
                                    </span>
                                </span>
                            </Div>
                            {!!props.isValid &&
                            <Div
                                theme={{ padding: { "": { l: 2 }, "sm": { l: 3 } } }}
                            >
                                <Button
                                    link={{
                                        onClick: () =>
                                            props.onClick(),
                                    }}
                                    className="scl-a-btn--big"
                                    style={{marginRight: "10px"}}
                                    theme={{ palette: ThemePalette.CONTRAST_PRIMARY }}
                                >
                                    {props.debit !== true ? "Generate Excasso" : "Generate Incasso"}
                                </Button>
                            </Div>
                            }
                        </Div>
                    </Div>
                </NavbarStackRight>
            </NavbarStack>
        </Navbar>
    </Div>
);
